<div class="row" id="gridView">
  @if (datas.length <= 0) {
  <div class="col-12">
    <div class="alert alert-primary bergh-text-primary text-center">
      Geen data gevonden
    </div>
  </div>
  } @for (data of datas; track data; let p = $index) {
  <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-3" id="cell-{{ p }}">
    <div class="card border-0 rounded-0 bergh-shadow-one">
      <div class="card-body p-0">
        <h5
          class="card-title w-100 bergh-bg-primary text-white m-0 text-truncate"
          [ngClass]="{
            'bergh-bg-primary': data.status === 'active',
            'bg-secondary': data.status === 'inactive'
          }"
        >
          {{ data.title }}
        </h5>
        @if (isHoverImage) {
        <div class="image-section">
          <div
            class="image-container bg-white border-bottom d-flex justify-content-center"
          >
            <img
              src="{{ data.img ? data.img : 'assets/no_image_available.jpg' }}"
              alt="No image"
              height="120"
            />
          </div>
        </div>
        }
        <ul class="list-group list-group-flush">
          @for (listItem of data.list; track listItem; let k = $index) {
          <li class="list-group-item border-0 d-flex align-items-center">
            <div class="icon">
              <i-feather
                name="{{ listItem.icon }}"
                class="small-icon"
              ></i-feather>
            </div>
            <div class="data">
              <p class="m-0 bergh-text-primary" id="label-{{ p }}-{{ k }}">
                {{ listItem.title }}
              </p>
              <h5
                class="m-0"
                id="text-{{ p }}-{{ k }}"
                [ngClass]="setStyle(listItem)"
              >
                {{ listItem.data }}
              </h5>
            </div>
          </li>
          }
          <li
            class="list-group-item border-top d-flex align-items-center justify-content-end flex-wrap"
          >
            @for (sBtn of data.secondaryButtonGroup; track sBtn; let i = $index)
            {
            <button
              class="btn btn-secondary {{ sBtn.class ? sBtn.class : '' }}"
              title="{{ sBtn.title }}"
              data-toggle="tooltip"
              (click)="secondaryButtonResponse.emit({ _id: data._id, btn: i, action: sBtn.action })"
              id="secondaryBtn-{{ p }}-{{ i }}"
            >
              <i-feather name="{{ sBtn.icon }}" class="small-icon"></i-feather>
            </button>
            } @for (pBtn of data.primaryButtonGroup; track pBtn; let j = $index)
            {
            <button
              class="btn bergh-btn-secondary text-white {{
                pBtn.class ? pBtn.class : ''
              }}"
              title="{{ pBtn.title }}"
              data-toggle="tooltip"
              (click)="primaryButtonResponse.emit({ _id: data._id, btn: j, action: pBtn.action })"
              id="primaryBtn-{{ pBtn.icon }}-{{ p }}-{{ j }}"
            >
              <i-feather name="{{ pBtn.icon }}" class="small-icon"></i-feather>
            </button>
            }
          </li>
        </ul>
      </div>
    </div>
  </div>
  }
</div>
